import { render } from "./qs-ctp-kaz-view.vue?vue&type=template&id=2fa68a14"
import script from "./qs-ctp-kaz-view.vue?vue&type=script&setup=true&lang=js"
export * from "./qs-ctp-kaz-view.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/tep/tep-nsi/qs-ctp-kaz-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2fa68a14"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2fa68a14', __exports__)) {
    api.reload('2fa68a14', __exports__)
  }
  
  module.hot.accept("./qs-ctp-kaz-view.vue?vue&type=template&id=2fa68a14", () => {
    api.rerender('2fa68a14', render)
  })

}


export default __exports__